<form [formGroup]="archivoForm">
    <p>Inicie el proceso seleccionando una sección del colegio e importando el archivo de <strong>Prime Timetable</strong> correspondiente.</p>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Escuela</mat-label>
        <mat-select formControlName="escuela">
            <mat-option *ngFor="let escuela of escuelas$ | async" [value]="escuela.key">
                {{escuela.value}}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="archivoForm.get('escuela').invalid && archivoForm.get('escuela').touched">
            {{'Este campo es requerido.'}}
        </mat-error>
    </mat-form-field>
    <div *ngIf="loading$ | async">
        <mat-progress-bar></mat-progress-bar>
    </div>
    <div>
        <button mat-button color="primary" type="button" mat-button
        (click)="fileInput.click()">Cargar archivo</button>
        <input hidden type="file" name="image" #fileInput (change)="fileProgress($event)" formControlName="archivo" required>
        <p class="mat-small" *ngIf="archivoForm.get('archivo').value !== ''" style="opacity: .6;"><strong>Archivo seleccionado:</strong> {{archivoForm.get('archivo').value}}</p>
        <mat-error *ngIf="archivoForm.get('archivo').invalid && archivoForm.get('archivo').touched">
            {{'Por favor cargue el archivo de Prime Timetable'}}
        </mat-error>
    </div>
</form>
